import { useEffect } from 'react';
import styled from 'styled-components';

import type { Breadcrumb } from '../../components/ToolkitV2/Breadcrumbs/Breadcrumbs.typed';
import { Breadcrumbs } from '../../components/ToolkitV2/Breadcrumbs/Breadcrumbs';
import { useRouter } from 'next/router';

const Container = styled.div`
  padding-top: ${({ theme }) => theme.spacing.M24};
  margin-bottom: ${({ theme }) => theme.spacing.XL64};
  width: 100%;

  > iframe {
    min-height: 100vh;
  }
`;

export interface NewCarFinanceProps {
  dschFinanceDomain: string;
  make: string;
  platform: string;
}

function NewCarFinance({
  dschFinanceDomain,
  make,
  platform,
}: NewCarFinanceProps) {
  const breadcrumbs: Array<Breadcrumb> = [
    {
      href: '/',
      displayName: 'Home',
    },
    { displayName: 'New Car Finance' },
  ];

  useEffect(() => {
    window.addEventListener('message', handleScrollToTop);

    return () => window.removeEventListener('message', handleScrollToTop);
  }, []);

  function handleScrollToTop({ data }: MessageEvent) {
    if (data === 'scroll_to_top') {
      window.scrollTo(0, 0);
    }
  }

  const { back } = useRouter();

  return (
    <>
      <div className="row">
        <div className="columns small-12">
          <Breadcrumbs breadcrumbs={breadcrumbs} goBack={back} />
        </div>
      </div>
      <div className="row small-collapse">
        <div className="columns">
          <Container>
            <iframe
              loading="lazy"
              width="100%"
              data-hj-allow-iframe=""
              src={`${dschFinanceDomain}/make/${make}${
                platform && `?platform=${platform}`
              }`}
              frameBorder="0"
            ></iframe>
          </Container>
        </div>
      </div>
    </>
  );
}

export { NewCarFinance };
